// Named-fix symbology rendered as a small SVG map image. Standard FAA
// IFR enroute chart convention: a 5-letter named waypoint is rendered
// as a small filled blue triangle with a halo for legibility on any
// basemap. Boss feedback 2026-05-10: previous purple dot was easy to
// miss, doesn't match any chart convention, and confused with navaids.

import type { Map as MlMap } from 'maplibre-gl';
import { ensureSvgImages } from './iconRegistry';

const SIZE = 18;
const TRI_FILL = '#3b82f6';   // chart blue (matches FAA enroute)
const TRI_HALO = '#0b0d0f';

function svgFixTriangle(): string {
  // Equilateral triangle pointing up, centered. Solid form (matches
  // FAA enroute "compulsory reporting fix" symbol; hollow form is
  // non-compulsory but most users don't differentiate at EFB sizes).
  const cx = SIZE / 2;
  const cy = SIZE / 2;
  const r = 6.5;
  const tx = cx, ty = cy - r;
  const blx = cx - r * Math.sin(Math.PI / 3);
  const bly = cy + r * Math.cos(Math.PI / 3);
  const brx = cx + r * Math.sin(Math.PI / 3);
  const bry = cy + r * Math.cos(Math.PI / 3);
  return `
    <svg xmlns="http://www.w3.org/2000/svg" width="${SIZE}" height="${SIZE}" viewBox="0 0 ${SIZE} ${SIZE}">
      <polygon points="${tx.toFixed(2)},${ty.toFixed(2)} ${brx.toFixed(2)},${bry.toFixed(2)} ${blx.toFixed(2)},${bly.toFixed(2)}"
               fill="${TRI_HALO}" stroke="${TRI_HALO}" stroke-width="3.4" stroke-linejoin="round"/>
      <polygon points="${tx.toFixed(2)},${ty.toFixed(2)} ${brx.toFixed(2)},${bry.toFixed(2)} ${blx.toFixed(2)},${bly.toFixed(2)}"
               fill="${TRI_FILL}" stroke="${TRI_FILL}" stroke-width="1.4" stroke-linejoin="round"/>
    </svg>
  `;
}

export const FIX_LEGEND_SVG = svgFixTriangle();

export function ensureFixIcons(map: MlMap): Promise<void> {
  return ensureSvgImages(
    map,
    [{ id: 'fix-tri', svg: svgFixTriangle() }],
    { defaultSize: SIZE, logTag: '[fixIcons]' },
  );
}
